'use strict';

var currentRoute; // current route
var quantityValue; // min order quantity
var addToCartUrl;
let script = document.createElement('script');
var tagmanager = require('./tagmanagerVTO');
script.onload = () => {
    $(document).on('click', '.tryOnButton', function () {
        let tryOnButton = $(this);
        let pid = tryOnButton.attr('data-pid');
        var options = {
            brandId: tryOnButton.attr('data-brand-id')
        };
        // store last clicked product info as a global fallback for analytics
        try {
            window.vtLastClicked = {
                pid: pid,
                productName: tryOnButton.attr('data-product-name')
            };
        } catch (e) {
            // ignore
        }
        currentRoute = tryOnButton.attr('data-route');
        addToCartUrl = tryOnButton.attr('data-cart-url');
        quantityValue = parseInt(tryOnButton.attr('data-quantity'), 10);

        var isAuthenticated = $('#customer-authenticated').val() === 'true';

        if (!isAuthenticated) {
            // store VTO intent and all relevant data so we can resume after login
            localStorage.setItem('virtualTryOnOpen', JSON.stringify({
                pid: pid,
                brandId: options.brandId,
                route: currentRoute,
                addToCartUrl: addToCartUrl,
                quantity: quantityValue,
                clickedClass: 'tryOnButton',
                triggered: true
            }));

            // If the user closes the login modal without authenticating, remove the stored VTO intent.
            $('#loginPopupModal').one('hidden.bs.modal', function () {
                try {
                    var isAuthenticatedAfter = $('#customer-authenticated').val() === 'true';
                    if (!isAuthenticatedAfter) {
                        try {
                            localStorage.removeItem('virtualTryOnOpen');
                        } catch (e) {
                            // do nothing
                        }
                    }
                } catch (e) {
                    // do nothing
                }
            });
            $('#loginPopupModal').modal('show');

            return;
        }

        if (typeof window.initMirrarUI === 'function') {
            window.initMirrarUI(pid, options);
        }
    });
};
script.src = 'https://cdn.mirrar.com/general/scripts/mirrar-ui.js';
document.body.append(script);

/**
 * Resumes the virtual try on process after user login.
 * @param {Object} data - Data object containing product and session information.
 */
window.resumeVirtualTryOn = function (data) {
    if (!data || !data.pid) return;

    /**
     * Tries to initialize the Mirrar UI.
     * @returns {boolean} True if initialization was successful, false otherwise.
     */
    function tryInit() {
        if (typeof window.initMirrarUI === 'function') {
            try {
                var options = { brandId: data.brandId, availabilityStatus: 'In-Stock' };
                window.initMirrarUI(data.pid, options);
                currentRoute = data.route;
                addToCartUrl = data.addToCartUrl;
                quantityValue = parseInt(data.quantity, 10);
            } catch (e) {
                // in case initMirrarUI fails
            }
            try {
                localStorage.removeItem('virtualTryOnOpen');
            } catch (e) {
                // localStorage may be unavailable (private mode / browser restriction)
            }
            return true;
        }
        return false;
    }

    if (!tryInit()) {
        var intId = setInterval(function () {
            if (tryInit()) {
                clearInterval(intId);
            }
        }, 500);
        setTimeout(function () { clearInterval(intId); }, 15000);
    }
};

/**
 * @param {string} pid - ProductId
 */
function addToCart(pid) {
    var raw = window.localStorage.getItem('addToCartData');
    if (raw) {
        try {
            var addData = JSON.parse(raw);
            if (addData && typeof addData === 'object') {
                addData.trigger = true;
                window.localStorage.setItem('addToCartData', JSON.stringify(addData));
            }
        } catch (e) {
            // do nothing
        }
    }
    if (currentRoute === 'Product-Show') {
        if (!$('.button-add').hasClass('d-none')) {
            $('.button-add .add-to-cart').click();
        } else {
            // showing the error msg
            $('.toast-error-container').removeClass('hide-error-toast');
        }
        document.querySelector('.go-to-cart').click();
    } else {
        var form = {
            pid: pid,
            quantity: quantityValue,
            virtualTryOn: true
        };
        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: form,
            success: function (data) {
                window.location.href = data.redirectUrl;
            },
            error: function () {
            }
        });
    }
}

var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
var eventer = window[eventMethod];
var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
eventer(messageEvent, function (e) {
    if (e.origin === 'https://cdn.mirrar.com') {
        tagmanager.tryItOn(e.data);
        if (e.data.event === 'add-to-cart' && e.data.data.element === 'mirrar-cart-added') {
            var pid = e.data.data.productCode;
            addToCart(pid);
        }
    }
});
